import { ClassNames } from "@emotion/react";
import React, { useEffect, useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import Button from "../Button/Button";
import { FaUserCircle } from "react-icons/fa";
import { HiOutlineSearch } from "react-icons/hi";
import Style from "./DesktopHeader.module.css";
import { useDispatch, useSelector } from "react-redux";
import Input from "../Input";
import SignupModal from "../SignupModal/SignupModal";
import LoginModal from "../LoginModal/LoginModal";
import ForgotPassModal from "../../pages/ForgotPassModal/ForgotPassModal";
import { AiOutlineShoppingCart } from "react-icons/ai";

import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Stack from "@mui/material/Stack";
import { signOutRequest } from "../../redux/auth/authSlice";
import ChangePasswordModal from "../ChangePasswordModal/ChangePasswordModal";

function DesktopHeader({
  className,
  containerClass,
  bgTransparent = false,
  sticky,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    isLogin,
    user,
    access_token: token,
  } = useSelector((state) => state.authReducer);
  const [scrollY, setScrollY] = useState(false);
  const [show, setShow] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] =
    useState(false);
  const cart = useSelector((state) => state?.cartReducer?.cart);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY >= 200) {
        setScrollY(true);
      } else {
        setScrollY(false);
      }
    });
  }, []);

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  // ----------------------------------------- Pop over menu Code Start
  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  // ----------------------------------------- Pop over menu Code End

  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      className={`${[
        Style.header,
        bgTransparent && Style.bgTransparent,
        sticky && Style.fixed,
        scrollY && Style.bgColor,
        className && className,
      ].join(" ")}`}
      id={"navDesktopHeader"}
    >
      <Container
        className={`${[
          Style.navbarContainer,
          containerClass && containerClass,
        ].join(" ")}`}
      >
        <Navbar.Brand onClick={() => navigate("/")} className="c-p">
          <div className={Style.imageContainer}>
            <h3>Card-Creator.com</h3>
            {/* <img src={logo} alt="Logo" /> */}
          </div>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className={`mx-auto ${[Style.gapCustm].join(" ")}`}>
            <NavLink
              to="/"
              className={`${Style.nabarLinks} ${
                window.location.pathname === "/" && Style.navActive
              }`}
            >
              Home
            </NavLink>

            <NavLink
              to="/collections"
              className={`${Style.nabarLinks} ${
                window.location.pathname === "/collections" && Style.navActive
              }`}
            >
              Collections
            </NavLink>
            <NavLink
              to="/cards"
              className={`${Style.nabarLinks} ${
                window.location.pathname === "/cards" && Style.navActive
              }`}
            >
              <span>Cards</span>
            </NavLink>

            <NavLink
              to="/template"
              className={`${Style.nabarLinks} ${
                window.location.pathname === "/template" && Style.navActive
              }`}
            >
              <span>Create Card</span>
            </NavLink>
            <NavLink
              to="/about"
              className={`${Style.nabarLinks} ${
                window.location.pathname === "/about" && Style.navActive
              }`}
            >
              <span>About Us</span>
            </NavLink>
          </Nav>

          <div className={[Style.dflex].join(" ")}>
            {isLogin ? (
              <div className={Style.searchBoxAndUser}>
                {cart?.length > 0 && (
                  <div
                    className={Style?.cartContainer}
                    onClick={() => navigate("/checkout")}
                  >
                    {cart?.length}
                    <AiOutlineShoppingCart />
                  </div>
                )}
                {/* <div className={Style.searchInputBox}>
                  <Input
                    placeholder={"Search"}
                    inputContainer={Style.searchInput}
                  />
                  <HiOutlineSearch className={Style.searchIcon} />
                </div> */}
                <div
                  className={Style.userNameAndIcon}
                  ref={anchorRef}
                  id="composition-button"
                  aria-controls={open ? "composition-menu" : undefined}
                  aria-expanded={open ? "true" : undefined}
                  aria-haspopup="true"
                  onClick={handleToggle}
                >
                  <span className="t-t-c">{user?.fullName}</span>
                  <FaUserCircle className={Style.userIcon} />
                </div>

                {/* Popper */}
                <Popper
                  className={Style?.muiPopper}
                  open={open}
                  anchorEl={anchorRef.current}
                  role={undefined}
                  placement="bottom-start"
                  transition
                  disablePortal
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === "bottom-start"
                            ? "left top"
                            : "left bottom",
                      }}
                    >
                      <Paper>
                        <ClickAwayListener onClickAway={handleClose}>
                          <MenuList
                            autoFocusItem={open}
                            id="composition-menu"
                            aria-labelledby="composition-button"
                            onKeyDown={handleListKeyDown}
                          >
                            <MenuItem
                              onClick={() => {
                                navigate("/my-cards");
                                handleClose();
                              }}
                            >
                              Dashboard
                            </MenuItem>
                            <MenuItem
                              onClick={() => {
                                setIsChangePasswordModalOpen(true);
                                handleClose();
                              }}
                            >
                              Update Password
                            </MenuItem>
                            <MenuItem
                              onClick={() => {
                                dispatch(signOutRequest());
                                navigate("/");
                                handleClose();
                              }}
                            >
                              Logout
                            </MenuItem>
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </div>
            ) : (
              <>
                <Button
                  onClick={() => {
                    setShow(true);
                  }}
                  label="Signup"
                  className={Style.loginBtn}
                  customStyle={{ marginRight: "20px" }}
                />
                <Button
                  onClick={() => {
                    setShowLogin(true);
                  }}
                  label="Login"
                  className={Style.loginBtn}
                />
              </>
            )}
          </div>
        </Navbar.Collapse>
      </Container>

      {showLogin && (
        <LoginModal
          show={showLogin}
          setShow={setShowLogin}
          setShowForgotModal={setShowForgotModal}
          setShowSignupModal={setShow}
        />
      )}
      {show && (
        <SignupModal
          show={show}
          setShow={setShow}
          setShowLogin={setShowLogin}
        />
      )}
      {showForgotModal && (
        <ForgotPassModal show={showForgotModal} setShow={setShowForgotModal} />
      )}

      {isChangePasswordModalOpen && (
        <ChangePasswordModal
          show={isChangePasswordModalOpen}
          setShow={setIsChangePasswordModalOpen}
        />
      )}
    </Navbar>
  );
}

export default DesktopHeader;
